import clsx from 'clsx'

// Shared label for the inline form fields on the member forms. Carries the
// dark-mode variant so individual labels no longer have to repeat it.
export function FieldLabel({ className, ...props }: React.ComponentPropsWithoutRef<'label'>) {
  return (
    <label
      {...props}
      className={clsx(className, 'block text-sm/6 font-medium text-gray-900 dark:text-gray-100')}
    />
  )
}
